import {
  AutoComplete,
  FormContainer,
  ISelectType,
  SwitchInput,
  Treturn,
  useFetch,
} from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  createAutomationTasyOrientation,
  getAutomationTasyOrientationById,
  updateAutomationTasyOrientationById,
} from "../../../../../../../services/automationTasyOrientation.service";
import {
  automationTasyOrientationSchema,
  TAutomationTasyOrientationForm,
} from "./AutomationTasyOrientationSchema";
import { IAutomationTasyOrientationProps } from "./models";
import { useAutomationRules } from "../../../../../../../store/contexts/AutomationRulesContext";
import MainApi from "../../../../../../../services/mainApi.service";

const translationPath = "chatBot.page.automations.AutomationTasyOrientation.";

const GENERIC_ROUTE = process.env.REACT_APP_MAIN + "/api/v1/Generic/";

const genericService = new MainApi<ISelectType>(GENERIC_ROUTE);

export const AutomationTasyOrientation = memo(
  ({
    id,
    ticketAutomationRuleId,
    onBackButton,
  }: IAutomationTasyOrientationProps) => {
    const { t } = useTranslation();

    const { automation } = useAutomationRules();

    const [optionsSendWhen, setOptionsSendWhen] = useState<ISelectType[]>([]);

    const [optionsTypeTasyOrientation, setOptionsTypeTasyOrientation] =
      useState<ISelectType[]>([]);

    const { sendRequest } = useFetch(genericService.list);

    const fetchGenericsSendWhen = useCallback(async () => {
      if (!automation) return;
      const { data, success } = await sendRequest({
        Identifier: "TicketAutomationMessageProtocolSendWhen",
      });
      var filtered = ["1"];
      if (data && success) {
        setOptionsSendWhen(
          data
            .filter((d) => filtered.includes(String(d.code)))
            .map((d) => ({
              id: d.id,
              name: d.name,
            }))
        );
      }
    }, [sendRequest, automation]);

    const fetchGenericsTypeTasyOrientation = useCallback(async () => {
      if (!automation) return;
      const { data, success } = await sendRequest({
        Identifier: "TypeTasyOrientation",
      });
      if (data && success) {
        setOptionsTypeTasyOrientation(
          data.map((d) => ({
            id: d.id,
            name: d.name,
          }))
        );
      }
    }, [sendRequest, automation]);

    useEffect(() => {
      fetchGenericsSendWhen();
      fetchGenericsTypeTasyOrientation();
    }, [fetchGenericsSendWhen, fetchGenericsTypeTasyOrientation]);

    const { sendRequest: save, loading: sLoading } = useFetch(
      createAutomationTasyOrientation
    );

    const { sendRequest: update, loading: uLoading } = useFetch(
      updateAutomationTasyOrientationById
    );

    const { sendRequest: get, loading: gLoading } = useFetch(
      getAutomationTasyOrientationById
    );

    const updateHandler = (v: TAutomationTasyOrientationForm, id: string) =>
      update({
        item: {
          id: id,
          ticketAutomationRuleId: ticketAutomationRuleId ?? "",
          sendWhenId: v.sendWhen.id,
          typeTasyOrientationId: v.typeTasyOrientation.id,
          enable: v.enable,
        },
        id: id,
      });

    const saveHandler = (v: TAutomationTasyOrientationForm) =>
      save({
        ticketAutomationRuleId: ticketAutomationRuleId ?? "",
        sendWhenId: v.sendWhen.id,
        typeTasyOrientationId: v.typeTasyOrientation.id,
        enable: v.enable,
      });

    const getHandler = useCallback(
      async (id: string): Promise<Treturn<TAutomationTasyOrientationForm>> => {
        const { data, success } = await get(id);

        if (data) {
          const newData: TAutomationTasyOrientationForm = {
            ...data,
            sendWhen: data.sendWhen,
            typeTasyOrientation: data.typeTasyOrientation,
            enable: data.enable,
          };
          return { data: newData, success: true };
        }
        return { data, success };
      },
      [get]
    );
    const successHandle = () => {
      onBackButton();
    };
    const loading = sLoading || uLoading || gLoading;
    return (
      <FormContainer<TAutomationTasyOrientationForm>
        saveFunction={saveHandler}
        updateFunction={updateHandler}
        getFunction={getHandler}
        loading={loading}
        title={t(translationPath + "title")}
        schema={automationTasyOrientationSchema}
        subtitle={t(translationPath + "new")}
        backButtonOnClick={onBackButton}
        redirectOnSave={false}
        onSuccess={successHandle}
        isModalForm={true}
        propId={id}
        formActionsOnBottom={false}
        fields={() => (
          <Grid container spacing={2}>
            <Grid item sm={12} textAlign={"end"}>
              <SwitchInput
                name="enable"
                label={t(translationPath + "enable")}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <AutoComplete
                getOptionLabel={({ name }) => name}
                size="small"
                label={t(translationPath + "send_when")}
                name="sendWhen"
                options={optionsSendWhen}
                clearIcon={false}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <AutoComplete
                getOptionLabel={({ name }) => name}
                size="small"
                label={t(translationPath + "type_tasy_orientation")}
                name="typeTasyOrientation"
                options={optionsTypeTasyOrientation}
                clearIcon={false}
              />
            </Grid>
          </Grid>
        )}
      />
    );
  }
);
